/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';

export interface IAlertCompProps {
  type?: 'error' | 'success';
  text?: string;
}

export const AlertComp = (props: IAlertCompProps) => {
  const { type, text } = props;
  return (
    <Alert key={type} variant={type}>
      {text}
    </Alert>
  );
};

AlertComp.defaultProps = {};
